import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { LogoAnimation } from './components/LogoAnimation';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Artists } from './pages/Artists';
import { EcoSystem } from './pages/EcoSystem';
import { News } from './pages/News';
import { Contact } from './pages/Contact';

function App() {
  const [showContent, setShowContent] = useState(false);

  return (
    <div className="App">
      <LogoAnimation onComplete={() => setShowContent(true)} />
      {showContent && (
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/ecosystem" element={<EcoSystem />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
